import React, { createContext, useCallback, useEffect, useState } from 'react';

import { actions, useAppDispatch } from '../store';
import { Attraction, BosEvent, Flow } from '../services/viva/constants';

export type OrderInitializationContextType = {
  attraction: Attraction;
  flow: Flow;
  event: BosEvent;
  reset: () => void;
};

export type OrderInitializationContextProviderProps = {
  children?: React.ReactNode;
  attraction?: Attraction;
  flow?: Flow;
  event?: BosEvent;
};

export const OrderInitializationContext =
  createContext<OrderInitializationContextType>({
    attraction: Attraction.TopOfTheRockObservationDeck,
    flow: Flow.TOR_GA,
    event: BosEvent.TOR_GA,
    reset: () => {
      /* no op */
    },
  });

export const OrderInitializationContextProvider = ({
  children,
  attraction = Attraction.TopOfTheRockObservationDeck,
  flow = Flow.TOR_GA,
  event = BosEvent.TOR_GA,
}: OrderInitializationContextProviderProps) => {
  const dispatch = useAppDispatch();
  const [isInitialRender, setIsInitialRender] = useState(true);

  const reset = useCallback(() => {
    if (!isInitialRender) return;

    dispatch(actions.order.initialize({ attraction, flow, event }));

    setIsInitialRender(false);
  }, [dispatch, attraction, flow, event, isInitialRender]);

  useEffect(() => {
    reset();
  });

  return (
    <OrderInitializationContext.Provider
      value={{ attraction, flow, event, reset }}
    >
      {children}
    </OrderInitializationContext.Provider>
  );
};
